import React, { Component } from 'react'
import { Icon, Button } from 'antd'
import { MODAL_TYPES, ModalFactory } from 'components/ModalFactory'
import { scheduler } from 'services/CeberusApiService';
import { PushNotification } from 'utils/PushNotification';
import { SchedulerRequest } from 'models/request/SchedulerRequest';
import { ActiveMessagePermission, Tenant } from 'models/Blip/Index';
import { TenantService } from 'connection/TenantService';

const UNRECOGNIZED_MODAL_TYPE = 'Unrecognized modal type';

export class Scheduler extends Component<{ match: any }> {
  
  formRef: any;
  identity: string;
  email: string;
  userName: string;
  locale: string;
  reason: string;
  tenantSelected: Tenant;

  state = {
    permissionNotGranted: false,
    isPermissionModalVisible: false,
    currentModal: MODAL_TYPES.SchedulerDenyPermission,
    requestStatus: {
      status: 'none',
      message: ''
    }
  }

  componentDidMount() {
    this.tenantSelected = TenantService.getSelectedTenant();
  }

  setPermission = async (permission: boolean) : Promise<void> => {
    try {
      const response = await scheduler(
        new SchedulerRequest(
          new ActiveMessagePermission(
            this.email,
            this.userName,
            this.locale,
            { description: this.reason ? this.reason : '' },
            permission,
            this.identity
          ), 
          this.tenantSelected.name, 
          this.identity));

      this.reason = ''
      this.setState({ requestStatus: {
        status: 'ok',
        message: response
      } });
      PushNotification.success(response);
    } catch (error) {
      this.setState({ requestStatus: {
        status: 'error',
        message: error.response.data
      } });
      PushNotification.httpError(error);
    }
  }

  grantPermission = async (permission: boolean) : Promise<void> => {
    this.setState({ requestStatus: { status: 'progress' } });
    if (permission) {
      await this.setPermission(true);
    }
    else {
      this.handleModalVisibility(MODAL_TYPES.SchedulerDenyPermission, true);
    }
  }

  saveFormRef = (formRef: any) : void => {
    this.formRef = formRef;
  }

  handleModalVisibility = (type: string, visibility: boolean) : void => {
    switch(type) {
      case MODAL_TYPES.SchedulerDenyPermission :
        this.setState({
          isPermissionModalVisible: visibility,
          currentModal: type,
          requestStatus: {
            status: 'none',
            message: ''
          }
        });
        break
      default:
        PushNotification.error(UNRECOGNIZED_MODAL_TYPE);
    }
  }

  handleSaveReason = async () : Promise<void> => {
    const form = this.formRef.props.form;

    form.validateFields(async (error, values) => {
      if (error) {
        return
      }

      const { reason } = values;
      this.reason = reason;
      form.resetFields();
      this.setState({ isPermissionModalVisible: false });
      await this.setPermission(false);
    })
  }

  render() {
    this.identity = this.props.match.params.identity;
    this.email = this.props.match.params.userEmail;
    this.userName = this.props.match.params.userName;
    this.locale = this.props.match.params.locale == 'pt-BR' || 'pt' ? 'pt' : 'en';

    if (!this.identity || !this.email || !this.userName) {
      return (
        <div className="tc">
          <h1>Scheduler</h1>

          <p>Put the bot identity, the user's email and name, and the locale in the URL, like so:</p>
          <p>scheduler/<b>identity@msging.net</b>/<b>email@email.com</b>/<b>Name</b>/<b>locale</b></p>
        </div>
      )
    }

    return (
      <div className="tc">
        <h1>Scheduler</h1>

        <p>Grant or deny scheduler permission to <b>{ this.identity }</b></p>
        <p>
          The email will be sent in English unless the locale <b>pt</b> is added to the URL:<br></br>
          scheduler/identity@msging.net/email@email.com/Name/<b>pt</b>
        </p>

        <Button type="primary" className="mr3" onClick={() => this.grantPermission(true)}>
          <Icon type="check-circle" /> Grant permission
        </Button>
        <Button type="primary" onClick={() => this.grantPermission(false)}>
          <Icon type="close-circle" /> Deny permission
        </Button>

        <br/>
        <br/>
        { this.state.requestStatus.status === 'progress' && <p>In progress...</p> }
        { this.state.requestStatus.status === 'ok' && <p style={{ color: '#4dcb7b' }}>{this.state.requestStatus.message}</p> }
        { this.state.requestStatus.status === 'error' && <p style={{ color: '#f76556' }}>{this.state.requestStatus.message}</p> }
       
        <ModalFactory
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.isPermissionModalVisible}
          onCancel={() => this.handleModalVisibility(MODAL_TYPES.SchedulerDenyPermission, false)}
          onOk={this.handleSaveReason}
          type={this.state.currentModal}
          maskClosable={false}
        />
      </div>
    )
  }
}